import { useState } from 'react';

import { NotificationContext, Severity } from './NotificationContext';

const defaultMessage = 'No message provided';

export const NotificationProvider = ({ children }: { children: React.ReactNode }) => {
  const [isOpened, setIsOpened] = useState(false);
  const [message, setMessage] = useState(defaultMessage);
  const [severity, setSeverity] = useState<Severity>('success');

  const showNotification = (message: string, severity: Severity) => {
    setMessage(message);
    setSeverity(severity);
    setIsOpened(true);
  };
  const hideNotification = () => {
    setIsOpened(false);
  };

  return (
    <NotificationContext.Provider
      value={{
        isVisible: isOpened,
        showNotification,
        hideNotification,
        message,
        severity,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};
